import React from 'react'
import useMedia from 'use-media'

import Label from '../../atoms/Label'
import Row from '../../atoms/Row'
import InputGroup from '../../atoms/InputGroup'
import MobileButtonGroup from '../../atoms/Search/MobileButtonGroup'
import Form from '../../atoms/Search/Form'

import ResetButton from '../../molecules/Search/ResetButton'
import ResetButtonLink from '../../molecules/Search/ResetButtonLink'
import LocationDropdown from '../../molecules/Search/LocationDropdown'
import BedroomButtonGroup from '../../molecules/Search/BedroomButtonGroup'
import MoveInDropdown from '../../molecules/Search/MoveInDropdown'
import PriceRangeSlider from '../../molecules/Search/PriceRangeSlider'
import ShareButton from '../../molecules/Search/ShareButton'
import ShowApartmentButtons from '../../molecules/Search/ShowApartmentsButton'

export default ({ show, markets, setShow, ...props }) => {
  const isMobile = useMedia({ maxWidth: '767.9px' })

  return (
    <Form show={show} {...props}>
      <Row>
        {!isMobile ? (
          <InputGroup>
            <Label>Reset</Label>
            <ResetButton type='gray700' />
          </InputGroup>
        ) : null}
        <InputGroup flex='1'>
          <Label>Locations</Label>
          <LocationDropdown
            flex='0 0 200px'
            attribute='allMarkets'
            searchable={true}
          />
        </InputGroup>
      </Row>
      <Row>
        <InputGroup>
          <Label>Bedrooms</Label>
          <BedroomButtonGroup attribute='floorplan.bedrooms' />
        </InputGroup>
        <InputGroup flex='1'>
          <Label>Move-in</Label>
          <MoveInDropdown flex='0 0 100px' attribute='unit.dateAvailableTimestamp' />
        </InputGroup>
      </Row>
      <Row>
        <InputGroup flex='1'>
          <Label>Price</Label>
          <PriceRangeSlider flex='0 0 100px' attribute='rent' />
        </InputGroup>
        <InputGroup>
          <Label>Share</Label>
          <ShareButton type='gray700' />
        </InputGroup>
      </Row>
      <MobileButtonGroup>
        <ShowApartmentButtons type='secondary' onClick={() => setShow()} />
        <ResetButtonLink type={props.type} />
      </MobileButtonGroup>
    </Form>
  )
}
